<template>
  <div class="list-head">
    <div class="row">
      <div class="col-12">
        <ul class="nav tabs" v-if="tabActive">
          <li
            v-if="!$isCallCenter"
            role="presentation"
            :class="{ active: tabActive === 'draft' }"
            @click="setTab('draft')"
            class="tab mx-3"
          >
            <h3>{{ $t("feature.article.tabs.draft") }}</h3>
            <p>{{ statusCount.draft }} รายการ</p>
          </li>
          <li
            v-if="!$isCallCenter"
            role="presentation"
            :class="{ active: tabActive === 'toBeApproved' }"
            @click="setTab('toBeApproved')"
            class="tab mx-3"
          >
            <h3>{{ $t("feature.article.tabs.toBeApproved") }}</h3>
            <p>{{ statusCount.toBeApproved }} รายการ</p>
          </li>
          <li
            v-if="!$isCallCenter"
            role="presentation"
            :class="{ active: tabActive === 'toBePublished' }"
            @click="setTab('toBePublished')"
            class="tab mx-3"
          >
            <h3>{{ $t("feature.article.tabs.toBePublished") }}</h3>
            <p>{{ statusCount.toBePublished }} รายการ</p>
          </li>
          <li
            role="presentation"
            :class="{ active: tabActive === 'published' }"
            @click="setTab('published')"
            class="tab mx-3"
          >
            <h3>{{ $t("feature.article.tabs.published") }}</h3>
            <p>{{ statusCount.published }} รายการ</p>
          </li>
          <li
            v-if="!$isCallCenter"
            role="presentation"
            :class="{ active: tabActive === 'all' }"
            @click="setTab('all')"
            class="tab mx-3"
          >
            <h3>{{ $t("feature.article.tabs.all") }}</h3>
            <p>{{ statusCount.all }} รายการ</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="filter-panel px-4 pb-3">
      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <label class="filter-label">โครงการ</label>
          <p class="filter-hint">
            พิมพ์รหัส (PAVE-BN) หรือชื่อไทย (เพฟ) — เลือกได้หลายโครงการ
          </p>
          <el-select
            v-model="selectedProjectIds"
            class="w-100"
            multiple
            filterable
            clearable
            collapse-tags
            placeholder="ทุกโครงการ"
            @change="emitFilters"
          >
            <el-option
              v-for="project in projects"
              :key="project.projectId"
              :label="projectOptionLabel(project)"
              :value="project.projectId"
            />
          </el-select>
        </div>

        <div class="col-12 col-md-6 mb-3" v-if="!$isCallCenter">
          <label class="filter-label">ผู้สร้าง</label>
          <p class="filter-hint">ตัดข่าวของแอดมินคนอื่นออก</p>
          <div class="created-by-toggle">
            <el-switch
              v-model="createdByMe"
              active-text="เฉพาะข่าวที่ฉันสร้าง"
              @change="emitFilters"
            />
          </div>
        </div>

        <div class="col-12 col-md-6 mb-3">
          <label class="filter-label">ช่วงวันที่ประกาศ</label>
          <p class="filter-hint" v-if="!isDraftTab">
            มีผลเฉพาะข่าวที่มีวันประกาศแล้ว
          </p>
          <p class="filter-hint" v-else>แบบร่างยังไม่มีวันที่ประกาศ</p>
          <div class="date-range d-flex align-items-center">
            <el-date-picker
              v-model="publishAtFrom"
              type="date"
              placeholder="dd/mm/yyyy"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              :disabled="isDraftTab"
              @change="emitFilters"
            />
            <span class="mx-2">ถึง</span>
            <el-date-picker
              v-model="publishAtTo"
              type="date"
              placeholder="dd/mm/yyyy"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              :disabled="isDraftTab"
              @change="emitFilters"
            />
          </div>
        </div>

        <div class="col-12 col-md-6 mb-3">
          <label class="filter-label">ค้นหา</label>
          <p class="filter-hint">ค้นจากหัวข้อข่าวเท่านั้น (ไม่เปลี่ยนในรอบนี้)</p>
          <div class="search-input-wrapper">
            <span class="search-icon">
              <i class="fas fa-search"></i>
            </span>
            <input
              type="text"
              class="form-control search-input"
              :placeholder="$t('feature.article.search.article_title')"
              v-model.lazy="currentSearchText"
              @keyup.enter="enterSearch"
            />
          </div>
        </div>
      </div>

      <p
        class="excluded-hint mb-0"
        v-if="showExcludedHint"
      >
        มี {{ excludedWithoutPublishAt }} รายการที่ถูกตัดออกเพราะยังไม่มีวันที่ประกาศ
      </p>
    </div>
  </div>
</template>
<script>
import debounce from "lodash/debounce";
import { baanRueJaiClient } from "@/dependencies";

const PROJECTS_CACHE_TTL_MS = 5 * 60 * 1000;
let projectsCache = null;
let projectsCacheLoadedAt = 0;
let projectsCachePromise = null;

function getCachedProjects() {
  if (
    projectsCache &&
    Date.now() - projectsCacheLoadedAt < PROJECTS_CACHE_TTL_MS
  ) {
    return Promise.resolve(projectsCache);
  }
  if (projectsCachePromise) {
    return projectsCachePromise;
  }
  projectsCachePromise = baanRueJaiClient.admin.projects
    .list()
    .then(res => {
      projectsCache = res.data || [];
      projectsCacheLoadedAt = Date.now();
      projectsCachePromise = null;
      return projectsCache;
    })
    .catch(err => {
      projectsCachePromise = null;
      throw err;
    });
  return projectsCachePromise;
}

export default {
  name: "list-head",
  props: [
    "tabActive",
    "statusCount",
    "searchText",
    "excludedWithoutPublishAt"
  ],
  data() {
    return {
      currentSearchText: this.searchText,
      projects: [],
      selectedProjectIds: [],
      createdByMe: false,
      publishAtFrom: null,
      publishAtTo: null
    };
  },
  computed: {
    isDraftTab() {
      return this.tabActive === "draft";
    },
    showExcludedHint() {
      const hasDateFilter = !!(this.publishAtFrom || this.publishAtTo);
      const relevantTab =
        this.tabActive === "all" || this.tabActive === "toBeApproved";
      return (
        hasDateFilter &&
        relevantTab &&
        Number(this.excludedWithoutPublishAt) > 0
      );
    }
  },
  watch: {
    tabActive(tab) {
      if (tab === "draft") {
        this.publishAtFrom = null;
        this.publishAtTo = null;
        this.emitFiltersImmediate();
      }
    }
  },
  created() {
    this.emitFiltersDebounced = debounce(() => {
      this.emitFilterPayload();
    }, 300);
    this.loadProjects();
  },
  beforeDestroy() {
    if (this.emitFiltersDebounced) {
      this.emitFiltersDebounced.cancel();
    }
  },
  methods: {
    setTab(tab) {
      this.$emit("tab", tab);
    },
    enterSearch() {
      this.$emit("search", this.currentSearchText);
    },
    projectOptionLabel(project) {
      const name = project.projectName || "";
      const code = project.projectCode || "";
      if (name && code) {
        return `${name} (${code})`;
      }
      return name || code || String(project.projectId);
    },
    loadProjects() {
      getCachedProjects()
        .then(projects => {
          this.projects = projects;
        })
        .catch(() => {
          this.projects = [];
        });
    },
    emitFilterPayload() {
      this.$emit("filters", {
        projectIds: this.selectedProjectIds,
        createdByMe: this.createdByMe,
        publishAtFrom: this.isDraftTab ? null : this.publishAtFrom,
        publishAtTo: this.isDraftTab ? null : this.publishAtTo
      });
    },
    emitFilters() {
      this.emitFiltersDebounced();
    },
    emitFiltersImmediate() {
      if (this.emitFiltersDebounced) {
        this.emitFiltersDebounced.cancel();
      }
      this.emitFilterPayload();
    }
  }
};
</script>

<style lang="scss" scoped>
.list-head {
  .tabs {
    height: 72px;
    padding: 16px 24px 0 16px;

    .tab {
      border: none;
      color: #8c8786;
      letter-spacing: -0.1px;
      font-weight: 500;
      text-align: left;
      min-width: 110px;

      &.active {
        border-bottom: 2px solid $orange;

        h3 {
          font-weight: bold;
          color: $black;
        }
        p {
          font-weight: bold;
          color: $orange;
        }
      }
      h3 {
        font-size: 16px;
        line-height: 1.38;
        color: inherit;
        margin: 0;
      }
      p {
        font-size: 11px;
        line-height: 1.64;
        color: inherit;
      }
    }
  }

  .filter-panel {
    border-top: 1px solid #eee;
    padding-top: 16px;
  }

  .filter-label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #424242;
    margin-bottom: 2px;
  }

  .filter-hint {
    font-size: 12px;
    color: #9e9e9e;
    margin-bottom: 8px;
  }

  .created-by-toggle {
    min-height: 40px;
    display: flex;
    align-items: center;
  }

  .date-range {
    .el-date-editor {
      width: 100%;
    }
  }

  .excluded-hint {
    font-size: 12px;
    color: #e65100;
  }

  .search-input-wrapper {
    position: relative;
    width: 100%;

    .search-icon {
      position: absolute;
      left: 14px;
      top: 50%;
      transform: translateY(-50%);
      color: #9e9e9e;
      z-index: 1;
      pointer-events: none;
    }

    .search-input {
      width: 100%;
      height: 40px;
      padding-left: 38px;
      font-size: 14px;
      font-weight: 500;
      color: #616161;
      border: 1px solid #ced4da;
      border-radius: 25px;
      box-shadow: none;

      &:focus {
        border-color: #adb5bd;
        box-shadow: none;
        outline: none;
      }
    }
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .list-head {
    .tabs {
      .tab {
        min-width: 70px;
      }
    }
  }
}
</style>
